/// <reference path="../../../declarations.d.ts" />
import React, { useRef } from 'react';
import { useReveal } from '../hooks/useScrollReveal';
import demoVideo from 'url:../../../../assets/demo-black.mp4';

const LandingDemo: React.FC = () => {
  const ref = useReveal();
  const videoRef = useRef<HTMLVideoElement>(null);

  return (
    <section id="demo" className="relative py-8 md:py-12 bg-white overflow-hidden scroll-mt-20">
      {/* Very subtle dot grid */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(circle, #000 0.5px, transparent 0.5px)',
        backgroundSize: '20px 20px'
      }} />

      <div ref={ref} className="relative z-10 max-w-7xl mx-auto px-6 flex flex-col items-center">
        {/* Widescreen Plain Video Container */}
        <div className="w-full sr delay-2">
          <div className="relative group">
            {/* Soft Ambient Glow backdrop */}
            <div className="absolute -inset-6 rounded-[2.5rem] bg-gradient-to-br from-violet-100/20 via-emerald-100/10 to-sky-100/10 blur-2xl opacity-50 glow-pulse" />

            {/* Video Box */}
            <div className="relative bg-black rounded-[1.5rem] border border-black/[0.06] shadow-[0_4px_40px_-15px_rgba(0,0,0,0.08)] overflow-hidden aspect-[16/9] w-full flex items-center justify-center">
              <video
                ref={videoRef}
                className="w-full h-full object-cover"
                autoPlay
                loop
                muted
                playsInline
              >
                <source src={demoVideo} type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingDemo;

